import { IconButton } from '@material-ui/core';
import { Blank$ } from 'app/tools/general.types';
import { BLANK$ } from 'app/tools/utils';
import { useSubscription } from 'observable-hooks';
import React, { useReducer, useRef } from 'react';
import 'styled-components/macro';
import AppImage from '../app-image/AppImage';
import Icon from '../icon/Icon';
import IconLib from '../icon/icon-lib';

type Props = {
  promptForImage$: Blank$;
  clearStoredImage$?: Blank$;
  onFileSelected: (imageFile: File | null) => unknown;
  noPreview?: boolean;
  className?: string;
};

export default function AddImageAndPreview({
  promptForImage$,
  clearStoredImage$ = BLANK$,
  onFileSelected,
  noPreview,
  className,
}: Props): JSX.Element {
  const [imagePreviewUrl, setImagePreviewUrl] = useReducer(
    (oldUrl: string, newUrl: string) => {
      if (oldUrl && oldUrl !== newUrl) {
        URL.revokeObjectURL(oldUrl);
      }
      return newUrl;
    },
    ''
  );

  const imageInputRef = useRef<HTMLInputElement>(null);
  useSubscription(promptForImage$, () =>
    imageInputRef.current?.click()
  );
  useSubscription(clearStoredImage$, () => {
    setImagePreviewUrl('');
  });

  const clearImage = () => {
    onFileSelected(null);
    setImagePreviewUrl('');
  };

  const handleImageSelect = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    e.preventDefault();
    const file = e.target.files?.[0];
    if (!file) return;
    if (imageInputRef.current) {
      // reset input value state by setting to null
      (imageInputRef.current.value as string | null) = null;
    }

    onFileSelected(file);
    setImagePreviewUrl(URL.createObjectURL(file));
  };

  return (
    <>
      {!noPreview && (
        <div className="relative">
          <AppImage
            alt="uploaded image"
            src={imagePreviewUrl}
            onError={clearImage}
            noPad
            {...{ className }}
          />
          <IconButton
            size="small"
            onClick={() => clearImage()}
            className="absolute text-white top-[12px] right-[12px]"
          >
            <Icon icon={IconLib.CROSS_BOXED} />
          </IconButton>
        </div>
      )}
      <input
        id="image-input"
        accept="image/*"
        type="file"
        ref={imageInputRef}
        onChange={handleImageSelect}
        className="hidden"
      />
    </>
  );
}
